export const testimonialsData = [
    {
        name: "THIAGO MORAES",
        role: "CORDENADOR DE PARCERIAS ESTRATÉGICAS NA YDUQS",
        text:
        "[CLUBE DO ALUNO]: Gostaríamos de deixar registrado a nossa imensa satisfação em ter o MeuCupom como parceiro da YDUQS. A plataforma atende muito bem todos os nossos requisitos, além de ser um acesso rápido e prático. Um super diferencial da empresa é a agilidade no atendimento, a equipe está sempre a postos para ajudar no que for preciso.",
        tag: "[CLUBE DO ALUNO]",
    },
    {
        name: "LEANDRO LOPES NOGUEIRA",
        role: "DIRETOR DE RET E FIDELIZAÇÃO NA UNIVERSIDADE CRUZEIRO DO SUL",
        text:
        "[CRUZEIRO DO SUL]: Estamos muito satisfeitos com essa união! A equipe do MeuCupom sempre está disposta em ajudar, solucionar e trazer novas estratégias para nosso produto. Que hoje consiste em uma plataforma de benefícios, chamada Mais Cupom, para toda rede de alunos, pólos parceiros e colaboradores por todo Brasil.",
        tag: "[CRUZEIRO DO SUL]",
    },
    {
        name: "THIAGO MORAES",
        role: "CORDENADOR DE PARCERIAS ESTRATÉGICAS NA YDUQS",
        text:
        "[CLUBE DE VANTAGENS]: O MeuCupom nos apoia ainda como relacionamento com diversas marcas do mercado, com o objetivo de promover as melhores condições comerciais para serem divulgadas na plataforma, como benefício exclusivo que oferecemos para os alunos das nossas instituições.",
        tag: "[CLUBE DE VANTAGENS]",
    },
];
